import React from "react";

import { faCompress, faDownload, faExpand } from "@performyard/fontawesome/pro-regular-svg-icons";
import { ButtonStandard } from "@performyard/py-components";

import css from "../OrgChart.module.scss";

interface ChartToolbarProps {
	onExpandAll: () => void;
	onCollapseAll: () => void;
	onExportPng: () => void;
}

export function ChartToolbar({ onExpandAll, onCollapseAll, onExportPng }: ChartToolbarProps) {
	return (
		<div data-interactive className={css.toolbar}>
			<div className={css.controlRow}>
				<ButtonStandard
					variant="outline"
					color="neutral"
					size="medium"
					iconLeft={faExpand}
					onClick={onExpandAll}
					dangerouslySetClassName="w-fit bg-white"
				>
					Expand All
				</ButtonStandard>
				<ButtonStandard
					variant="outline"
					color="neutral"
					size="medium"
					iconLeft={faCompress}
					onClick={onCollapseAll}
					dangerouslySetClassName="w-fit bg-white"
				>
					Collapse All
				</ButtonStandard>
				<ButtonStandard
					variant="outline"
					color="neutral"
					size="medium"
					iconLeft={faDownload}
					onClick={onExportPng}
					dangerouslySetClassName="w-fit bg-white"
				>
					Export PNG
				</ButtonStandard>
			</div>
		</div>
	);
}
